import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { SizeTracker } from '../../common/SizeTracker'
import { Element } from '../../common/html/element'
import { Icon } from '../../common/html/icon'
import { Loading } from '../../common/loading'
import { Notification } from '../../common/notification'
import { ScrollComponent } from '../../common/scrollComponent'
import { Tooltip } from '../../common/tooltip'
import classes from '../index.module.scss'
import { selectLoading } from '../store/slice'
import ItemCompany from './ItemCompany'

const CompanyList = ({
  items,
  title,
  tooltipContent,
  isSimilar,
  keyLoading,
}) => {
  const loading = useSelector(selectLoading(keyLoading))
  return (
    <Element
      className="w50 h100 flexColumn"
      style={{ border: '1px solid #D5D5D5' }}
    >
      <Element
        style={{
          backgroundColor: '#D5D5D5',
          color: '#191D25',
          fontSize: 14,
        }}
        className={classes.headerContent}
      >
        <Translate value={title} />
        <Tooltip
          tooltipStyle={{
            maxWidth: 150,
            textAlign: 'center',
          }}
          tooltipContent={<Translate value={tooltipContent} />}
        >
          <Icon className="icon-info-circle ml1" style={{ color: '#9C9C9C' }} />
        </Tooltip>
      </Element>
      <SizeTracker
        bottomClassName="flex1"
        renderBottomComponent={(size) => {
          return (
            <>
              {!items.length ? (
                <div className={`${classes.noData} positionRelative`}>
                  {loading ? (
                    <Loading />
                  ) : (
                    <Notification isI18n value="common.NO_DATA" />
                  )}
                </div>
              ) : (
                <div className="h100">
                  <ScrollComponent autoHeight autoHeightMax={size?.height}>
                    {items.map((item, index) => {
                      return (
                        <ItemCompany
                          key={item.id}
                          id={item.id}
                          item={item}
                          index={index}
                          isSimilar={isSimilar}
                        />
                      )
                    })}
                  </ScrollComponent>
                </div>
              )}
            </>
          )
        }}
      />
    </Element>
  )
}

CompanyList.propTypes = {
  items: PropTypes.array.isRequired,
  title: PropTypes.string,
  tooltipContent: PropTypes.string,
  isSimilar: PropTypes.bool,
}

CompanyList.defaultProps = {
  isSimilar: false,
}

export default CompanyList
